"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 36: TXC 01-22000-400
 * ------------------------------------------------------------------ *
 * Two games are known to require this definition:
 *   - Strike Wolf (also released as Comando de Lobos)
 *   - Policeman
 *
 * CHR banking is implemented with two 7400-series ICs:
 *   $4200 write: [.... CCCC] - Select 8 KiB CHR bank
 *
 * PRG banking is part of the ASIC:
 *   $4100 read:  [xxRR xxxx] - Copy internal register 'RR' to data bus
 *   $4100 write: If Increment is set, 'RR' <- 'RR'+1
 *                Otherwise, if Invert is clear, 'RR' <- 'PP'
 *                If Invert is set, 'RR' <- ~'PP'
 *   $4101 write: [...V ....] - Invert Mode
 *   $4102 write: [..PP ....] - Copy data bus to internal register 'PP'
 *   $4103 write: [...C ....] - Increment Mode
 *   $8000 write: copy 'RR' to PRG banking pins
 * ------------------------------------------------------------------ */

function register(Mappers) {
  Mappers[36] = function (nes) {
    this.nes = nes;
  };

  Mappers[36].prototype = new Mappers[0]();

  Mappers[36].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);

    this.chrBank = 0;
    this.prgBank = 0;

    // Internal registers
    this.RR = 0;  // Register to be read
    this.PP = 0;  // Register to be copied to RR
    this.invertMode = false;
    this.incrementMode = false;
  };

  Mappers[36].prototype.write = function (address, value) {
    if (address >= 0x8000) {
      // $8000 write: copy 'RR' to PRG banking pins
      this.prgBank = this.RR & 0x0F;
      this.loadRomBank(this.prgBank, 0x8000);
      this.loadRomBank(this.prgBank, 0xC000);
      return;
    }

    if (address === 0x4200) {
      // CHR bank select
      this.chrBank = value & 0x0F;
      this.load8kVromBank(this.chrBank, 0x0000);
      return;
    }

    if (address === 0x4100) {
      if (this.incrementMode) {
        // Increment mode: 'RR' <- 'RR'+1
        this.RR = (this.RR + 1) & 0x0F;
      } else {
        if (this.invertMode) {
          // Invert mode: 'RR' <- ~'PP'
          this.RR = (~this.PP) & 0x0F;
        } else {
          // Normal: 'RR' <- 'PP'
          this.RR = this.PP & 0x0F;
        }
      }
      return;
    }

    if (address === 0x4101) {
      // Invert mode
      this.invertMode = (value & 0x10) !== 0;
      return;
    }

    if (address === 0x4102) {
      // Copy data bus to internal register 'PP'
      this.PP = (value >> 4) & 0x0F;
      return;
    }

    if (address === 0x4103) {
      // Increment mode
      this.incrementMode = (value & 0x08) !== 0;
      return;
    }

    if (address < 0x6000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }
  };

  Mappers[36].prototype.load = function (address) {
    address &= 0xffff;

    if (address === 0x4100) {
      // Read internal register 'RR'
      return (address & 0xF0) | (this.RR & 0x0F);
    }

    if (address >= 0x6000) {
      return this.readPrg(address);
    }

    return Mappers[0].prototype.load.apply(this, arguments);
  };

  Mappers[36].prototype.readPrg = function (address) {
    if (address >= 0x8000) {
      return this.nes.cpu.mem[address];
    }
    return Mappers[0].prototype.load.apply(this, arguments);
  };

  Mappers[36].prototype.updateBanks = function () {
    var rom = this.nes.rom;
    if (!rom || rom.romCount === 0) {
      return;
    }

    this.loadRomBank(this.prgBank, 0x8000);
    this.loadRomBank(this.prgBank, 0xC000);

    this.load8kVromBank(this.chrBank, 0x0000);
  };

  Mappers[36].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("Mapper 36: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();

    this.updateBanks();

    this.resetIrqHandler();
  };

  Mappers[36].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.chrBank = this.chrBank;
    s.prgBank = this.prgBank;
    s.RR = this.RR;
    s.PP = this.PP;
    s.invertMode = this.invertMode;
    s.incrementMode = this.incrementMode;
    return s;
  };

  Mappers[36].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.chrBank = s.chrBank;
    this.prgBank = s.prgBank;
    this.RR = s.RR;
    this.PP = s.PP;
    this.invertMode = s.invertMode;
    this.incrementMode = s.incrementMode;
    this.updateBanks();
  };
}

module.exports = { register: register };
